import CryptoJS from 'crypto-js';
// 防抖函数
export const debounce = <T extends (...args: any[]) => any>(
  fn: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

// 图片加载优化
export const getImageUrl = (url: string, width?: number) => {
  if (!url) return '';
  if (!width) return url;
  // 如果是阿里云OSS，添加图片处理参数
  if (url.includes('oss-cn-shenzhen.aliyuncs.com')) {
    return `${url}?x-oss-process=image/resize,w_${width}/quality,q_80`;
  }
  return url;
};

// 格式化数字
export const formatNumber = (num: number) => {
  return new Intl.NumberFormat('zh-CN').format(num);
};

// 日期格式化
export const formatDate = (date: Date | string) => {
  return new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

/**
 * 将URL参数转换为对象
 *
 * @param url 要解析的URL，默认为当前窗口的URL
 * @returns 返回一个包含URL参数的对象，若URL中无参数则返回空对象
 */
export const getParams2Object = (url = '') => {
  if (url.includes('?')) {
    const keyValueArr = url.split('?')[1].split('&');
    const paramObj = {} as Record<any, any>;
    keyValueArr.forEach(item => {
      const keyValue = item.split('=');
      paramObj[keyValue[0]] = keyValue[1];
    });
    return paramObj;
  }
  return {};
};

export const isMobile = () => {
  // 判断是否为移动设备
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

export const goLogin = () => {
  console.log('test');
  window.open(`${process.env.NEXT_PUBLIC_SCRM_ADMIN_URL}/platform/#/login`);
};

export const MD5encryption = (word: string) => {
  if (!word) return '';
  return CryptoJS.MD5(word).toString();
};
